import { render, staticRenderFns } from "./loanDetailsDialog.vue?vue&type=template&id=9ba35158&scoped=true"
import script from "./loanDetailsDialog.vue?vue&type=script&lang=js"
export * from "./loanDetailsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ba35158",
  null
  
)

export default component.exports